import de from './de'
import Utils from '../Utils'

var deMsg = {
  'agreements.title': 'Vereinbarungen',
  'agreements.error.mandatory': "Sie müssen zustimmen, um die Dienste von Deeper weiterhin in Anspruch zu nehme" +
      "n",
  'agreements.error.blank': "Bitte treffen Sie eine Wahl",
  'agreements.back': 'Zurück',
  'agreements.agree': 'Zustimmen',
  'agreements.decline': 'Ablehnen',
  'agreements.text.full': 'Völlige Übereinstimmung'
}

Utils.addTerms(deMsg, de)

export default deMsg



// WEBPACK FOOTER //
// ./src/lang/deMsg.js